var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastErrorSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74023 7.74023L14.7602 14.7602M14.7602 7.74023L7.74023 14.7602L14.7602 7.74023Z",
    stroke: "#F7323F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21C16.6348 21 21 16.6348 21 11.25C21 5.86522 16.6348 1.5 11.25 1.5C5.86522 1.5 1.5 5.86522 1.5 11.25C1.5 16.6348 5.86522 21 11.25 21Z",
    stroke: "#F7323F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastErrorSmall);
export default __webpack_public_path__ + "static/media/ToastErrorSmall.4653a083fac3522400f9553a65edcc4a.svg";
export { ForwardRef as ReactComponent };